"use client";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import Image from "next/image";
import { FC } from "react";
import React from "react";

import StubImageSrc from "@/imgs/welcome_screen.png";
import { Button, Typography } from "@/shared/ui";

import styles from "./error.module.scss";

Bugsnag.start({
  apiKey: "ff78d5177bbd22c70fbb9184e13661a8",
  plugins: [new BugsnagPluginReact()],
});

const BugsnagErrorBoundary = Bugsnag.getPlugin("react")!.createErrorBoundary(React);

const ErrorBoundary: FC = () => {
  return (
    <BugsnagErrorBoundary>
      <main className={styles.container}>
        <Image src={StubImageSrc} className={styles.welcomeImage} alt="welcome-image" />

        <div className={styles.content}>
          <div className={styles.top}>
            <Typography bold as="h1" variant="large-title" align="center">
              Oops! Something Went Wrong
            </Typography>
            <Typography as="h2" variant="footnote" align="center" className={styles.description}>
              The app has encountered an unexpected error. Please try refreshing the page or restarting the app.
            </Typography>
          </div>

          <div className={styles.bottom}>
            <Button size="big" variant="secondary" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </div>
        </div>
      </main>
    </BugsnagErrorBoundary>
  );
};

export default ErrorBoundary;
